import styled from "styled-components";

export const AppliedFiltersBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 5px;

    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    overflow: -moz-scrollbars-none;
    overflow-x: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        flex-wrap: nowrap;
        margin-top: 1rem;
        margin-bottom: 1rem;
        &:empty {
            margin-top: 0;
            margin-bottom: 0;
        }
    }
`